import styled from 'styled-components';

const FloatButton = styled.a`
  display: flex;
  align-items: center !important;
  cursor: pointer !important;
  background: ${({ theme }) => theme.headerBgColor}!important;
  bottom: 32px !important;
  //border-radius: 100% !important;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15) !important;
  display: flex !important;
  fill: ${({ theme }) => theme.headerFontColor} !important;
  color: ${({ theme }) => theme.headerFontColor} !important;
  justify-content: center !important;
  position: fixed !important;
  right: 32px !important;
  transform: ${props => props.opened ? 'scale(0)' : 'scale(1)'} !important;
  transition: transform .3s ease !important;
  //width: 56px !important;
  //height: 56px !important;
  z-index: 999 !important;
  padding: 10px!important;
  font-size: 19px;
  border: 0px;
  border-radius: ${({theme}) => (parseInt(theme.headerFontSize)+20)/2 + 'px'} !important;
  //background: #1A73E9 !important;
  line-height: 1;
  
`;

FloatButton.defaultProps = {
  theme: {
    headerBgColor: '#6e48aa',
    headerFontColor: '#fff',
  },
};

export default FloatButton;
